import * as React from "react";
import { connect, useSelector } from "react-redux";
import { Model } from "@flowable/forms";
import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import Icon from "@cayuse/shared-react.components.icon";
import { request } from "utils/proxy";
import Modal from "@cayuse/shared-react.components.modal";
import styles from "./styles.css";
import { fetchPicklistOptions } from "store/actions/picklists";
import CovertButton from "@cayuse/shared-react.components.covert-button";
import Radio from "@cayuse/shared-react.components.form.inputs.radio";



class AddResearchTeamMember extends Model.StatefulFormComponent {
	state = {
		touched: true,
		formValid: true,
		loading: true,
		value: null,
		hasPrincipalInvestigator: false,
		memberToAssociationLookupMap: {},
		fetchedAllMembers: [],
		isNewLineSelected: true,
		initialLoad: true,
	};


	async componentDidMount () {
		fetchPicklistOptions("researchTeamRoles");

		if (this.state.value === null) {
			const initialValue = isNonEmptyArray(this.props.config.value)
				? this.props.config.value
				: [ {
					id: Math.floor(Math.random() * 1000 ) + 1,
					member: null,
					role: null,
					associations: [ {
						association: null
					} ],
					baseSalary: 0,
					effort: 0,
					personMonths: 0,
					isResearchTeamMember: true,
					reqSalary: 0,
					fringeRate: 0,
					fringeRequested: 0,
					apptMonths: ""
				} ] ;
			for (const member of initialValue) {
				this.createNewAssociationIfNeededAndRemoveEmpty(member.associations);
			}
			const hasPrincipalInvestigator = this.hasPrincipalInvestigator(initialValue);
			this.lookupAssociations(initialValue)
				.then(memberToAssociationLookupMap => {
					this.setState({
						value: this.deepCopy(initialValue),
						successful: true,
						loading: false,
						hasPrincipalInvestigator,
						memberToAssociationLookupMap
					});
				});
		}

		if(isNonEmptyArray(this.props.config.value)) {
			this.setState({ initialLoad: false });
		}
	}

	lookupAssociations (value) {
		let promises = [];
		for (const member of value) {
			const personId = member.member;
			if (AddResearchTeamMember.isPresent(personId)) {
				promises.push(request("/sp/api/person/" + personId)
					.then(person => {
						return { personId: personId, associations: this.convertAssociations(person.associations) };
					}));
			}
		}

		return Promise.all(promises)
			.then(mappings => {
				let associationLookupMap = {};
				for (const mapping of mappings) {
					associationLookupMap[mapping.personId] = mapping.associations;
				}

				return associationLookupMap;
			});
	}

	convertAssociations (associations) {
		return (associations || []).map(association => ({ id: association.id, text: association.name }));
	}

	componentDidUpdate () {
	}

	shouldComponentUpdate (nextProps, nextState) {
		return nextState !== this.state;
	}

	render () {
		const { onChange, Components, config: { enabled }  } = this.props;
		const { loading, initialLoad } = this.state;

		const disabled = this.props.config.enabled === false;
		const bem = this.bem("panel", { disabled });

		return loading ? (<div>Loading...</div>) : (
			<div className={bem()}>
				<Components.description {...this.props}/>
				{
					this.state.value.map((item, index) => this.renderMember(item, index, bem))
				}
			</div>
		);
	}

	renderMember (item, index, bem) {
		const { config, Components, onChange } = this.props;
		const { value, members, isNewLineSelected, onAdd } = this.state;
		const options = {
			newCategory: "newCategory",
			newLine: "newline"
		};
		let memberConfig = this.getSelectConfig(`Name <span class="${styles.red}">*</span>`, config.$path, index, "member", item, members);
		memberConfig.extraSettings = this.extraSettingsRest();
		memberConfig.$original = {
			extraSettings: memberConfig.extraSettings
		};
		let roleConfig = this.getSelectConfig(`Role <span class="${styles.red}">*</span>`, config.$path, index, "role", item, this.getRoles(item));

		let setContent = (field, newValue) => {
			this.updateValue(onChange, value => value[index][field] = newValue);
		};

		let key = `${index}-`;

		let handleRadioFalse = () => {
			let stateValue = this.state.value;

			stateValue[0].associations = [ {
				association: null
			} ];
			stateValue[0].member = null;
			stateValue[0].role = null;
			this.setState({ isNewLineSelected: false, value: stateValue });
			setContent("member", "6a1cf675-cf32-4789-96ea-79168ac89f5d" );
		};

		let handleRadioTrue = () => {
			let stateValue = this.state.value;

			stateValue[0].associations = [ {
				association: null
			} ];
			stateValue[0].member = null;
			stateValue[0].role = null;
			this.setState({ isNewLineSelected: true, value: stateValue });
		};

		return (

			<div key={`row-${index}`} className={`${styles.member} ${styles.lightGreyBackground}`}>
				<Modal.Content className={styles.modalContent}>
					<Radio
						id={options.newCategory}
						name="typeGroup"
						checked={isNewLineSelected}
						value={options.newCategory}
						onChange={handleRadioTrue}

					>
						{"Add a specific person currently affiliated with the institution."}
					</Radio>
					<Radio
						id={options.newLine}
						name="typeGroup"
						checked={!isNewLineSelected}
						value={options.newLine}
						onChange={handleRadioFalse}
					>
						{"Add a person to be named later (i.e. a postdoc or lab tech who is not yet hired)"}
					</Radio>
				</Modal.Content>



				{isNewLineSelected ?
					<div className={`${bem("row")} ${styles.memberInfo}`}>
						<div className={bem(`col--6`)}>
							<Components.select {...this.props} ckey={`${key}-member`} key={`${key}-member`}
											   config={memberConfig}
											   onChange={value => setContent("member", value)}
							/>
						</div>
						<div className={bem(`col--5`)}>
							<Components.select {...this.props} ckey={`${key}-role`} key={`${key}-role`} config={roleConfig}
																		 onChange={value => setContent("role", value)}
							/>
						</div>
					</div>
					:
					<div className={`${bem("row")} ${styles.memberInfo}`}>
						<div className={bem(`col--6`)}>
							<Components.select {...this.props} ckey={`${key}-role`} key={`${key}-role`} config={roleConfig}
																		 onChange={value => setContent("role", value)}
							/>
						</div>
					</div>}




				{
					value[index].associations.map((association, subIndex) => {
						return this.renderAssociation(onChange, index, subIndex, association, bem, key, Components);
					})
				}
			</div>
		);
	}

	renderAssociation (onChange, index, subIndex, association, bem, key, Components) {
		const { value, memberToAssociationLookupMap, isNewLineSelected,  fetchedAllMembers } = this.state;
		const { config } = this.props;

		const	fetchAssociations = () => {
			let fetchedAssociations = [];

			return request(`/sp/api/unit?search=`)
				.then( data => {
					data.map(data => {
						const association = {};
						association.id = data.id;
						association.text = data.name;
						fetchedAssociations.push(association);
					});

					return fetchedAssociations;
				});
		};

		fetchAssociations().then(data => this.state.fetchedAllMembers = data);



		let setAssociationContent = (field, newValue) => {
			this.updateValue(onChange, (value => {
				value[index].associations[subIndex][field] = newValue;
			}));
		};

		let deleteEntry = () => {
			this.updateValue(onChange, value => value[index].associations.splice(subIndex, 1));
		};

		let addAssociation = () => {
			this.updateValue(onChange, value => value[index].associations.push({
				// Placeholder - returns first association in the lookup
				// ToDo: Identify the primary association and make that the auto-filled association
				association: (
					memberToAssociationLookupMap[value[index].member]
						? memberToAssociationLookupMap[value[index].member][0].id
						: null
				)
			}));
		};



		let associations = [];
		if (AddResearchTeamMember.isPresent(value[index].member)) {
			associations = memberToAssociationLookupMap[value[index].member];
		}
		let associationConfig = this.getSelectConfig(
			`Association <span class="${styles.red}">*</span>`,
			config.$path + "associations.0",
			index,
			"association",
			association,
			(isNewLineSelected) ? associations : fetchedAllMembers
		);

		let isLastElement = subIndex === value[index].associations.length - 1;

		if (isLastElement
			&& !AddResearchTeamMember.isPresent(association.association)
		) {
			// hide errors for last element if both are not filled out
			associationConfig.$errors = [];
		}

		return (
			<div className={bem("row")} key={`row-${index}-${subIndex}`}>
				<div className={bem(`col--2`)}>&nbsp;</div>
				<div className={bem(`col--4`)}>
					<Components.select {...this.props} ckey={`${key}-${subIndex}-association`}
									   key={`${key}-${subIndex}-association`}
									   config={associationConfig}
									   onChange={value => setAssociationContent("association", value)}
					/>
				</div>
				{
					value[index].associations.length > 1
						?
						<CovertButton disabled={!config.enabled} onClick={deleteEntry} className={`${styles.marginLeft}`}>
							<Icon
								className={`${config.enabled ? styles.red : styles.grey} ${styles.marginTop}`}
								name="times"
								onClick={deleteEntry}
								size="bigger"
							/>
						</CovertButton>
						: ""
				}
				{
					isLastElement
						?
						<CovertButton disabled={!config.enabled} onClick={addAssociation} className={`${styles.marginLeft}`}>
							<Icon
								className={`${config.enabled ? styles.blue : styles.grey} ${styles.marginTop}`}
								name="plus"
								size="bigger"
							/>
						</CovertButton>
						: ""
				}
			</div>
		);
	}


	createNewAssociationIfNeededAndRemoveEmpty (associations) {
		if (associations.length === 0) {
			associations.push({
				association: null
			});
		}
	}

	updateValue (onChange, setValue) {
		const { value } = this.state;
		setValue(value);
		onChange(this.cleanupForPayload(value));
		const hasPrincipalInvestigator = this.hasPrincipalInvestigator(value);
		this.lookupAssociations(value)
			.then(memberToAssociationLookupMap => {
				this.setState({
					value: this.deepCopy(value),
					hasPrincipalInvestigator,
					memberToAssociationLookupMap,
					initialLoad: false
				});
			});
	}


	cleanupForPayload (content) {
		let members = [];
		for (const originalMember of content) {
			const member = {
				member: originalMember.member,
				role: originalMember.role,
				associations: []
			};
			for (const association of originalMember.associations) {
				if (AddResearchTeamMember.isPresent(association.association)) {
					member.associations.push(association);
				}
			}
			members.push(member);
		}

		return members;
	}


	getRoles (item) {
		const { hasPrincipalInvestigator } = this.state;
		const { roles } = this.props;
		const filterPI = () => roles.filter(({ id }) => id !== "principal-investigator");

		return isNonEmptyArray(roles) && hasPrincipalInvestigator && !this.isPrinicpalInvestigator(item)
			? filterPI()
			: [ ...roles ];
	}

	hasEmptyAssociation (associations) {
		return associations.find(association => this.isEmptyAssociation(association)) !== undefined;
	}

	isEmptyAssociation (association) {
		return association.association === undefined || association.association === null;
	}

	hasPrincipalInvestigator (teamMembers) {
		return teamMembers.find(teamMember => this.isPrinicpalInvestigator(teamMember)) !== undefined;
	}

	isPrinicpalInvestigator (teamMember) {
		return teamMember.role === "principal-investigator";
	}

	getSelectConfig (label, path, index, field, item, items) {
		let value = item[field];

		return {
			label: label,
			$path: `${path}.${index}.${field}`,
			type: "select",
			$errors: AddResearchTeamMember.validateIsRequired(value),
			value: value,
			enabled: this.props.config.enabled,
			extraSettings: this.extraSettings(items)
		};
	}

	getNumberConfig (label, path, index, field, item) {
		const value = item[field];

		return {
			label: label,
			$path: `${path}.${index}.${field}`,
			type: "number",
			value: value,
			enabled: this.props.config.enabled,
			extraSettings: {
				min: 0,
				max: 100
			}
		};
	}

	static validateIsRequired (value, errors = []) {
		if (!this.isPresent(value)) {
			errors.push("isRequired");
		}

		return errors;
	}

	static isPresent (value) {
		return value !== undefined && value !== null && value !== "";
	}

	extraSettings = items => {
		return {
			enableAutocomplete: true,
			dataSource: "Static",
			items: items,
			storage: "Id",
			identity: "id",
			multi: false
		};
	};

	extraSettingsRest = () => {
		return {
			tagsEnabled: false,
			preselectAll: false,
			enableAutocomplete: true,
			autocompleteMinLength: 1,
			dataSource: "Rest",
			queryUrl: "{{endpoints.cayuse}}/person?search={{$searchText}}",
			lookupUrl: "{{endpoints.cayuse}}/person/{{$id}}",
			formatItem: "{{$item.name}}",
			storage: "Id",
			identity: "id",
			linkTarget: "_blank",
			linkUrl: "",
			multi: false
		};
	};

	deepCopy (value) {
		return JSON.parse(JSON.stringify(value));
	}

	static $addValidations (column) {
		column.$errors = [];
		let researchTeams = column.value;
		while (isNonEmptyString(researchTeams)) {	//this loop is for the cases where there's a nested string
			researchTeams = JSON.parse(researchTeams);
		}
		column.value = researchTeams;
		if (!researchTeams) {
			column.$errors.push("isRequired");

			return;
		}

		if (researchTeams.length === 0) {
			column.$errors.push("isRequired");
		}

		for (const researchTeam of researchTeams) {
			AddResearchTeamMember.validateIsRequired(researchTeam.member, column.$errors);
			AddResearchTeamMember.validateIsRequired(researchTeam.role, column.$errors);
			if (!AddResearchTeamMember.isPresent(researchTeam.associations) || researchTeam.associations.length === 0) {
				column.$errors.push("isRequired");
			} else {
				for (const association of researchTeam.associations) {
					AddResearchTeamMember.validateIsRequired(association.association, column.$errors);
				}
			}
		}
	}
}

const mapStateToProps = state => ({
	roles: state.picklists.researchTeamRoles?.options || []
});

export default connect(mapStateToProps)(AddResearchTeamMember);

